enum UserRole {
    admin = 'Admin',
    user = 'User',
    reader = 'reader',
    backoffice = 'backoffice',
    groupAdmin = 'groupadmin',
}

export default UserRole;
